import { SAFEA_V3_ENABLED, SAFEA_VERSION, SAFEA_VERSIONS } from '~/constants/_core/safea-v3';

const SESSION_TOKEN = `${process.env.APPLICATION_ALIAS}_sessionToken`;
const SESSION_TOKEN_V3 = `${process.env.APPLICATION_ALIAS}_sessionTokens`;

const _getSessionToken = ({ $cookiz }) => {
  if (process.server) {
    return $cookiz.get(SESSION_TOKEN, { fromRes: true }) || $cookiz.get(SESSION_TOKEN, { fromRes: false }) || null;
  }

  return window.sessionStorage.getItem(SESSION_TOKEN);
};

const _setSessionToken = (sessionToken, { store, $cookiz }) => {
  // The SSR needs to know which tab has focus.
  if (store.state.isSSR) {
    $cookiz.set(SESSION_TOKEN, sessionToken);
  }

  if (process.client) {
    if (!sessionToken) {
      window.sessionStorage.removeItem(SESSION_TOKEN);
    } else {
      sessionStorage.setItem(SESSION_TOKEN, sessionToken);
    }
  }
};

export default ({ app, store }, inject) => {
  inject('session', {
    getTokenName() {
      return SESSION_TOKEN;
    },
    setTabFocus() {
      if (!store.state._core.auth.token) {
        return;
      }
      const sessionToken = _getSessionToken({ $cookiz: app.$cookiz });

      _setSessionToken(sessionToken, { store, $cookiz: app.$cookiz });
    },
    set(token, tokenIsSame = true) {
      if (SAFEA_V3_ENABLED) {
        throw new Error('[Cockpit] The $session.set method cannot be used with Safe A v3');
      }

      if (!store.state._core.auth.token) {
        return;
      }
      let sessionToken = _getSessionToken({ $cookiz: app.$cookiz });

      sessionToken = (tokenIsSame && sessionToken) ? sessionToken : token;

      _setSessionToken(sessionToken, { store, $cookiz: app.$cookiz });
    },
    get() {
      return _getSessionToken({ $cookiz: app.$cookiz });
    },
    clear() {
      if (store.state.isSSR) {
        app.$cookiz.remove(SESSION_TOKEN);
      }

      if (process.client) {
        window.sessionStorage.removeItem(SESSION_TOKEN);
        window.sessionStorage.removeItem(SESSION_TOKEN_V3);
      }
    },

    // v3
    // TODO: SSR compatibility
    getTokenNameV3() {
      return SESSION_TOKEN_V3;
    },
    getTokens() {
      return JSON.parse(window.sessionStorage.getItem(SESSION_TOKEN_V3));
    },
    setTokens(tokens) {
      if (SAFEA_VERSION !== SAFEA_VERSIONS.V3) {
        if (tokens.refreshToken) {
          window.sessionStorage.setItem(SESSION_TOKEN, tokens.refreshToken);
        } else {
          window.sessionStorage.removeItem(SESSION_TOKEN);
        }
      }
      window.sessionStorage.setItem(SESSION_TOKEN_V3, JSON.stringify(tokens));
    }
  });
};
